module.exports = __webpack_public_path__ + "media/images/MR_link_copied-52bbf24a.png";